// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const bollardLight = defineModel({
  id: "bollard-light",
  batchId: "future",
  name: "Bollard light",
  tags: ["scenery","bollard","light","low-poly","age-of-mcp","future"],
  summary: "A low bollard light — marks path edges and steps at night.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.12,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.07, 0.08, 0.04, 8), color: "#857f74", position: [0, 0.02, 0] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.06, 0.3, 8), color: "#6e6a62", position: [0, 0.19, 0] },
      { geometry: new THREE.CylinderGeometry(0.052, 0.052, 0.08, 8), color: "#ffe6a0", position: [0, 0.36, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.085, 6), color: "#fff3cc", position: [0, 0.36, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.055, 0.05, 8), color: "#33383d", position: [0, 0.43, 0] },
      { geometry: new THREE.SphereGeometry(0.018, 5, 4), color: "#33383d", position: [0, 0.47, 0] },
    ],
  animations: [],
});
